export default __webpack_public_path__ + "static/media/Item2.5d758bc6.png";